import React, { useState } from 'react';
import { MdChevronRight, MdOutlineMonetizationOn, MdOutlinePayment, MdOutlineQuestionAnswer } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './MenuList.scss';

function MenuItem({ icon, title, children, onClick }) {
    const [isOpen, setIsOpen] = useState(false);

    const IconComponent = icon;

    const handleItemClick = () => {
        if (onClick) {
            onClick(); // Execute the onClick function if provided
        }
        setIsOpen(!isOpen); // Toggle open/close of the submenu
    };

    return (
        <div className='menu-item' onClick={handleItemClick}>
            <IconComponent className='menu-icon' />
            <span className='menu-title'>{title}</span>
            <MdChevronRight className={`chevron ${isOpen ? 'open' : ''}`} />
            {isOpen && <div className='menu-content'>{children}</div>}
        </div>
    );
}

function MenuList() {
    const navigate = useNavigate();

    const handleEarningsClick = () => {
        navigate('/Range'); // Navigate to the earnings page
    };

    return (
        <div className='menu-list'>
            <MenuItem 
                icon={MdOutlineMonetizationOn} 
                title='my earnings' 
                onClick={handleEarningsClick} // Pass the navigation handler
            />
            <MenuItem icon={MdOutlinePayment} title='Payment settings' />
            <MenuItem icon={MdOutlineQuestionAnswer} title='Payment settings' />
        </div>
    );
}

export default MenuList;
